export var zeroRightClassName = 'right-scroll-bar-position';
export var fullWidthClassName = 'width-before-scroll-bar';
export var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
export var removedBarSizeVariable = '--removed-body-scroll-bar-size';
